import React from 'react';

import Table, {
    TableFooter,
    TablePagination,
    TableRow,
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';
import LinearProgress from 'material-ui/Progress';
import Button from 'material-ui/Button';

import List, {ListItem, ListItemSecondaryAction, ListItemText} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import {
    Add,
    Close, 
    Check, 
    Edit
} from 'material-ui-icons';
import Divider from 'material-ui/Divider';
import Grid from 'material-ui/Grid';

import Editation from './Editation';
import Filter from './Filter';

import axios from 'axios';
import moment from "moment-timezone";

class OfferList extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
		  locations: [],
      filter: {},
			rowsPerPage: 10,
		    page: 0,
		    total: 0,
			data: [],
			entity: {},
      formDisplay: false,
		};
	}

	componentDidMount() {
		this.loadEntities(1);

		axios.get('/api/operator/flight/locations')
    .then((res) => {
      this.setState({locations: res.data.data.sort((a, b) => a.name.localeCompare(b.name))});
    });
	}

	loadEntities(page) {
		axios.get('/api/operator/flight/offers?type=offers&page=' + page + '&perPage=' + this.state.rowsPerPage, {
		  params: this.state.filter
    })
			.then((response) => {
				//console.log(response.data);
				this.setState({
					data: response.data.data,
					page: response.data.current_page,
					total: response.data.total,
					rowsPerPage: parseInt(response.data.per_page),
					//entity: response.data.data[0]
				});
			});
	}

	handleChangePage(e, page) {
		this.loadEntities(page+1);	// paginator counts pages as indexes (starting 0)
	}

	handleClick = (model) => (e) => {
		this.setState({
			entity: model,
            formDisplay: true,
		});
        // TODO: Focus to editation form
	};

    closeEditation = () => {
        this.setState({
            entity: {},
            formDisplay: false,
        });
    }

	saveEntity = (model) => {
		if (!model.files) {
			model.files = [];	// when 
		}

        if (model.start_time) {
            const utcTime = moment(model.start_time).utc().toISOString();
            model.start_time = utcTime;
        }
		axios.post('/api/operator/flight/offers' + (model.id ? '/'+model.id : ''), model)
			.then((response) => {
                // TODO: feedback (success or failure)
                // TODO: here update data (call reloading of current page)
                this.closeEditation();

                this.loadEntities(this.state.page);
			});
	}

    createNew = () => {
        this.setState({
            entity: {
              files: [],
            },
            formDisplay: true
        });
        // TODO: Focus to editation form
    }

    renderStatusIcon = (status) => {
        if (!status.name) {
            return null;
        }
        let bgColor = 'white', 
            color = 'silver',
            icon = <Edit />;

        switch (status.name.toUpperCase()) {
            case 'ACTIVE':
                bgColor = "white"; color = "green";
                icon = (<Check />);
                break;

            case 'CANCELED':
                bgColor = "white"; color = "red";
                icon = (<Close />);
                break;

            case 'DRAFT':
            default:
                bgColor = "white"; color = "silver";
                icon = (<Edit />);
        }

        return (
            <Avatar style={{color: color, backgroundColor: bgColor}}>
                {icon}
            </Avatar>
        );
    };

    handleFilterChange = (filter) => {
      this.setState({
        filter
      }, () => this.loadEntities(1));
    };

    render() {
    	return (
    	<div>
        <Filter
          onChange={this.handleFilterChange}
          locations={this.state.locations}
        />
        		
    		<div style={this.state.formDisplay ? {} : {display: "none"}}>
        		<Editation
                    locations={this.state.locations}
                    ref="editationForm"
                    entityData={this.state.entity ? this.state.entity : {}} 
                    saveEntity={this.saveEntity}
                    closeEditation={this.closeEditation}
            />
    		</div>

            {this.state.formDisplay ? '' : 

            <div>
                <Button raised fab color="accent" 
                    className="jr-fab-btn text-white"
                    style={{position: "fixed", bottom: 5, right: 5, zIndex: 9999}}
                    onClick={this.createNew}
                >
                    <Add />
                </Button>

                <Paper>
                    <div className="flex-auto">
                        <div className="table-responsive-material">
                            <List>
                                {this.state.data.map((model, index) => {
                                    return (<div key={model.id}>
                                        <ListItem button
                                            onClick={this.handleClick(model)}
                                        >
                                            {this.renderStatusIcon(model.status)}
                                            <Grid container spacing={0}>
                                                <Grid item sm={6} xs={12}>
                                                    <ListItemText className="br-break"
                                                        primary={model.title}
                                                        secondary={model.flight_type.title || ''}
                                                    />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                    <ListItemText className="br-break"
                                                        primary={<span><i className="zmdi zmdi-pin" />{' '}{(model.location.name || '-')}</span>}
                                                        secondary={<span><i className="zmdi zmdi-timer" />{' '}{(model.time_flight || '-')} min</span>}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                        <Divider light />
                                    </div>
                                    );
                                }, this)}
                                
                            </List>

                            <Table className="">
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={this.state.total}
                                            rowsPerPage={this.state.rowsPerPage}
                                            rowsPerPageOptions={[this.state.rowsPerPage]}
                                            page={this.state.page-1}
                                            onChangePage={(e, page) => {this.handleChangePage(e, page)}}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    </div>
            	</Paper>
            </div>
            
            }

        </div>
        );
    }
}

export default OfferList;


// WEBPACK FOOTER //
// ./app/used/offers/routes/List.js